<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item"><a :href="'/budget'">Budget</a></li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      Production Budget
      <small>
        Review your cost estimates from your script to find your way to be
        cost-effcient
      </small>
    </h1>
    <!-- end page-header -->

    <panel v-if="!loading" no-button="true" title="Budget tool">
      <b-tabs content-class="mt-3">
        <b-tab title="View by Space, Stuff, Staff and Service" active>
          <b-button-group class="mb-4">
            <b-button @click="exportToXls(0, tabOneTree)">
              Export to XLS
            </b-button>
          </b-button-group>

          <div class="mb-4">
            <h5>Cost Estimate Summary:</h5>
            <b-row>
              <b-col>
                <span class="font-weight-bold"> Cost estimate TOTAL </span>
              </b-col>
              <b-col cols="9">
                {{ tabOneCostEstimate.total | money }} EUR
              </b-col>
            </b-row>
            <div
              v-for="(type, typeKey) in tabOneCostEstimate.type"
              :key="typeKey"
            >
              <b-row class="text-left my-3">
                <b-col>
                  <span class="font-weight-bold">
                    {{ typeKey }}
                  </span>
                </b-col>
                <b-col cols="9"> {{ type.totalPrice | money }} </b-col>
              </b-row>
            </div>
            <hr class="my-4" />
          </div>

          <div v-for="(type, typeKey) in tabOneTree" :key="typeKey">
            <b-row class="text-left my-3">
              <b-col cols="12" sm="3">
                <div class="d-flex">
                  <h5>{{ type.name }}</h5>
                </div>
              </b-col>
              <b-col> </b-col>
              <b-col cols="1">
                <b-button
                  v-b-toggle="`fours-collapse-${typeKey}`"
                  variant="light"
                >
                  <b-icon-chevron-down class="when-closed" />
                  <b-icon-chevron-up class="when-open" />
                </b-button>
              </b-col>
            </b-row>

            <b-collapse :id="`fours-collapse-${typeKey}`" class="w-75 mt-2">
              <b-row>
                <b-col></b-col>
                <b-col cols="2" class="text-right">
                  <span class="font-weight-bold">Items Required </span>
                </b-col>
                <b-col cols="1" class="text-right">
                  <span class="font-weight-bold">Unit </span>
                </b-col>
                <b-col cols="2" class="text-right">
                  <span class="font-weight-bold"> Cost estimate per unit </span>
                </b-col>
                <b-col cols="2" class="text-right">
                  <span class="font-weight-bold"> Total cost estimate </span>
                </b-col>
              </b-row>

              <div
                v-for="mainCategory in type.categories"
                :key="mainCategory.id"
                class="my-2"
              >
                <div class="font-weight-bold">
                  {{ mainCategory.name }}
                </div>

                <div
                  v-for="subCategory in mainCategory.children"
                  :key="subCategory.id + '-sub-container'"
                  class="ml-4"
                >
                  <div>
                    {{ subCategory.name }}
                  </div>

                  <div
                    v-for="item in subCategory.items"
                    :key="item.id + '-item-container'"
                    class="ml-4"
                  >
                    <b-row>
                      <b-col>
                        <router-link
                          :to="`/eventbank/${
                            item.type ? item.type.name.toLowerCase() : null
                          }/items/${item.id}`"
                          class="text-black"
                        >
                          {{ item.name }}
                        </router-link>
                      </b-col>
                    </b-row>

                    <b-row
                      v-for="(scriptItem, scriptItemKey) in item.scriptItems"
                      :key="scriptItem.id + '-script-item-container'"
                      :class="
                        scriptItemKey % 2 === 0
                          ? 'py-2 bg-light'
                          : 'py-2 bg-white'
                      "
                    >
                      <b-col>
                        <router-link
                          :to="`/script/${
                            item.type ? item.type.name.toLowerCase() : null
                          }/${scriptItem.step ? scriptItem.step.id : null}`"
                          class="text-black"
                        >
                          <div class="ml-4">
                            {{ scriptItem.step ? scriptItem.step.name : '-' }}
                          </div>
                        </router-link>
                      </b-col>
                      <b-col cols="2" class="text-right">
                        {{ scriptItem.amount }}
                      </b-col>
                      <b-col cols="1" class="text-right">
                        {{ item.unit }}
                      </b-col>
                      <b-col cols="2" class="text-right">
                        {{ scriptItem.costEstimate | money }}
                      </b-col>
                      <b-col cols="2" class="text-right">
                        {{
                          (scriptItem.amount * scriptItem.costEstimate) | money
                        }}
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>

              <div class="font-weight-bold">Uncategorized</div>

              <div
                v-for="item in type.uncategorizedItems"
                :key="item.id + '-item-container'"
                class="ml-4"
              >
                <b-row>
                  <b-col>
                    <router-link
                      :to="`/eventbank/${
                        item.type ? item.type.name.toLowerCase() : null
                      }/items/${item.id}`"
                      class="text-black"
                    >
                      {{ item.name }}
                    </router-link>
                  </b-col>
                </b-row>

                <b-row
                  v-for="(scriptItem, scriptItemKey) in item.scriptItems"
                  :key="scriptItem.id + '-script-item-container'"
                  :class="
                    scriptItemKey % 2 === 0 ? 'py-2 bg-light' : 'py-2 bg-white'
                  "
                >
                  <b-col>
                    <router-link
                      :to="`/script/${
                        item.type ? item.type.name.toLowerCase() : null
                      }/${scriptItem.step ? scriptItem.step.id : null}`"
                      class="text-black"
                    >
                      <div class="ml-4">
                        {{ scriptItem.step ? scriptItem.step.name : '-' }}
                      </div>
                    </router-link>
                  </b-col>
                  <b-col cols="2" class="text-right">
                    {{ scriptItem.amount }}
                  </b-col>
                  <b-col cols="1" class="text-right">
                    {{ item.unit }}
                  </b-col>
                  <b-col cols="2" class="text-right">
                    {{ scriptItem.costEstimate | money }}
                  </b-col>
                  <b-col cols="2" class="text-right">
                    {{ (scriptItem.amount * scriptItem.costEstimate) | money }}
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </div>
        </b-tab>

        <b-tab title="View by Storyboards, stages and steps">
          <b-button-group class="mb-4">
            <b-button @click="exportToXls(1, tabTwoTree)">
              Export to XLS
            </b-button>
          </b-button-group>

          <div class="mb-4">
            <h5>Cost Estimate Summary:</h5>
            <b-row>
              <b-col>
                <span class="font-weight-bold"> Cost estimate TOTAL </span>
              </b-col>
              <b-col cols="9"> {{ tabTwoCostEstimate.total | money }} </b-col>
            </b-row>
            <div
              v-for="(
                storyboard, storyboardKey
              ) in tabTwoCostEstimate.storyboard"
              :key="storyboardKey"
            >
              <b-row class="text-left my-3">
                <b-col>
                  <span class="font-weight-bold">
                    {{ storyboardKey }}
                  </span>
                </b-col>
                <b-col cols="9"> {{ storyboard.totalPrice | money }} </b-col>
              </b-row>
            </div>
            <hr class="my-4" />
          </div>

          <div
            v-for="(storyboard, storyboardKey) in tabTwoTree"
            :key="storyboardKey"
          >
            <b-row class="text-left my-3">
              <b-col cols="12" sm="3">
                <div class="d-flex">
                  <h5>{{ storyboard.name }}</h5>
                </div>
              </b-col>
              <b-col> </b-col>
              <b-col cols="1">
                <b-button
                  v-b-toggle="`storyboard-collapse-${storyboardKey}`"
                  variant="light"
                >
                  <b-icon-chevron-down class="when-closed" />
                  <b-icon-chevron-up class="when-open" />
                </b-button>
              </b-col>
            </b-row>

            <b-collapse
              :id="`storyboard-collapse-${storyboardKey}`"
              class="w-75 mt-2"
            >
              <b-row>
                <b-col></b-col>
                <b-col cols="2" class="text-right">
                  <span class="font-weight-bold">Items Required </span>
                </b-col>
                <b-col cols="1" class="text-right">
                  <span class="font-weight-bold">Unit </span>
                </b-col>
                <b-col cols="2" class="text-right">
                  <span class="font-weight-bold"> Cost estimate per unit </span>
                </b-col>
                <b-col cols="2" class="text-right">
                  <span class="font-weight-bold"> Total cost estimate </span>
                </b-col>
              </b-row>

              <div
                v-for="stage in storyboard.stages"
                :key="stage.id"
                class="my-2"
              >
                <div class="font-weight-bold">
                  {{ stage.name }}
                </div>

                <div
                  v-for="step in stage.steps"
                  :key="step.id + '-step-container'"
                  class="ml-4"
                >
                  <b-row>
                    <b-col>
                      {{ step.name }}
                    </b-col>
                  </b-row>

                  <b-row
                    v-for="(scriptItem, scriptItemKey) in step.scriptItems"
                    :key="scriptItem.id + '-script-item-container'"
                    :class="
                      scriptItemKey % 2 === 0
                        ? 'py-2 bg-light'
                        : 'py-2 bg-white'
                    "
                  >
                    <b-col>
                      <router-link
                        :to="`/script/${
                          scriptItem.item && scriptItem.item.type
                            ? scriptItem.item.type.name.toLowerCase()
                            : null
                        }/${scriptItem.step && scriptItem.step.id}`"
                        class="text-black"
                      >
                        <div class="ml-4">
                          {{ scriptItem.item ? scriptItem.item.name : '-' }}
                        </div>
                      </router-link>
                    </b-col>
                    <b-col cols="2" class="text-right">
                      {{ scriptItem.amount }}
                    </b-col>
                    <b-col cols="1" class="text-right">
                      {{ scriptItem.item && scriptItem.item.unit }}
                    </b-col>
                    <b-col cols="2" class="text-right">
                      {{ scriptItem.costEstimate | money }}
                    </b-col>
                    <b-col cols="2" class="text-right">
                      {{
                        (scriptItem.amount * scriptItem.costEstimate) | money
                      }}
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-collapse>
          </div>
        </b-tab>
      </b-tabs>
    </panel>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { BIconChevronDown, BIconChevronUp } from 'bootstrap-vue'
import { authHeader } from '../helpers'

export default {
  components: {
    BIconChevronDown,
    BIconChevronUp
  },
  filters: {
    money(data) {
      const formatted = new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(data)
      return formatted
    }
  },
  computed: {
    tabOneTree() {
      let tree = [...this.$store.state.type.types]
      const items = JSON.parse(JSON.stringify(this.$store.state.item.items))

      tree = tree.map((type) => {
        type.categories = this.mainCategoryTree(type)

        type.categories = type.categories.map((category) => {
          category.children = category.children.map((subCategory) => {
            subCategory.items = subCategory.items.map((item) => {
              // Only script items used in active steps (step has stage and stage has storyboard)
              item.scriptItems = item.scriptItems.filter((scriptItem) => {
                const step = this.$store.state.step.steps.find(
                  (step) => step.id === scriptItem.step
                )
                if (!step) {
                  return false
                }
                const stage = this.$store.state.stage.stages.find(
                  (stage) => stage.id === step.stage
                )
                if (!stage) {
                  return false
                }
                const storyboard =
                  this.$store.state.storyboard.storyboards.find(
                    (storyboard) => storyboard.id === stage.storyboard
                  )
                if (!storyboard) {
                  return false
                }
                return true
              })

              item.scriptItems = item.scriptItems.map((scriptItem) => {
                if (typeof scriptItem.step !== 'object') {
                  scriptItem.step = [...this.$store.state.step.steps].find(
                    (step) => step && step.id === scriptItem.step
                  )
                }
                return scriptItem
              })
              return item
            })
            subCategory.items = subCategory.items.filter(
              (item) => item.scriptItems && item.scriptItems.length > 0
            )
            return subCategory
          })
          category.children = category.children.filter((subCategory) => {
            const scriptItemsInCategory = Boolean(
              subCategory.items.find((item) => item.scriptItems.length > 0)
            )
            return scriptItemsInCategory
          })
          return category
        })
        type.categories = type.categories.filter((category) => {
          const hasScriptItemsInSubCategories = Boolean(
            category.children.length > 0
          )
          return hasScriptItemsInSubCategories
        })
        type.uncategorizedItems = items.filter((item) => {
          return item.type.id === type.id && !item.category
        })
        type.uncategorizedItems = type.uncategorizedItems.map((item) => {
          item.scriptItems = item.scriptItems.map((scriptItem) => {
            if (typeof scriptItem.step !== 'object') {
              scriptItem.step = [...this.$store.state.step.steps].find(
                (step) => step && step.id === scriptItem.step
              )
            }
            return scriptItem
          })
          return item
        })
        return type
      })
      tree = tree.filter((type) => {
        return type.categories.length > 0
      })
      return tree
    },
    tabOneCostEstimate() {
      const tree = [...this.tabOneTree]
      const costEstimate = {
        total: 0,
        type: {}
      }
      tree.forEach((type) => {
        const typeKey = type.name
        if (!costEstimate.type[typeKey]) {
          costEstimate.type[typeKey] = {}
        }
        const typeItems = type.categories
          .map((category) => category.children)
          .flat()
          .map((category) => category.items)
          .flat()

        costEstimate.type[typeKey].totalPrice = 0

        typeItems.forEach((item) => {
          if (!item.scriptItems) {
            return
          }
          item.scriptItems.forEach((scriptItem) => {
            if (scriptItem.confirmed) {
              costEstimate.type[typeKey].totalPrice +=
                scriptItem.costEstimate * scriptItem.amount
            }
          })
        })

        type.uncategorizedItems.forEach((item) => {
          if (!item.scriptItems) {
            return
          }
          item.scriptItems.forEach((scriptItem) => {
            if (scriptItem.confirmed) {
              costEstimate.type[typeKey].totalPrice +=
                scriptItem.costEstimate * scriptItem.amount
            }
          })
        })

        costEstimate.total += costEstimate.type[typeKey].totalPrice
      })
      return costEstimate
    },
    tabTwoTree() {
      let tree = JSON.parse(
        JSON.stringify(this.$store.state.storyboard.storyboards)
      )
      let steps = JSON.parse(JSON.stringify(this.$store.state.step.steps))
      let scriptItems = JSON.parse(
        JSON.stringify(this.$store.state.scriptitem.scriptItems)
      )

      let types = [...this.$store.state.type.types]
      tree = tree.map((storyboard) => {
        storyboard.stages = storyboard.stages.map((stage) => {
          stage.steps = steps.filter((step) => step.stage === stage.id)
          stage.steps = stage.steps.map((step) => {
            step.scriptItems = scriptItems.filter(
              (scriptItem) => scriptItem.step.id === step.id
            )
            step.scriptItems = step.scriptItems.map((scriptItem) => {
              if (scriptItem.item) {
                if (typeof scriptItem.item.type !== 'object') {
                  scriptItem.item.type = types.find(
                    (type) => type.id === scriptItem.item.type
                  )
                }
              }
              return scriptItem
            })
            return step
          })
          stage.steps = stage.steps.filter(
            (step) => step.scriptItems.length > 0
          )
          return stage
        })
        storyboard.stages = storyboard.stages.filter((stage) => {
          const stageWithScriptItems = Boolean(
            stage.steps.find((step) => {
              return step.scriptItems.length > 0
            })
          )
          return stageWithScriptItems
        })
        return storyboard
      })
      tree = tree.filter((storyboard) => {
        return storyboard.stages.length > 0
      })
      return tree
    },
    tabTwoCostEstimate() {
      const tree = [...this.tabTwoTree]
      const costEstimate = {
        total: 0,
        storyboard: {}
      }
      tree.forEach((storyboard) => {
        const storyboardKey = storyboard.name
        if (!costEstimate.storyboard[storyboardKey]) {
          costEstimate.storyboard[storyboardKey] = {}
        }
        const storyboardScriptItems = storyboard.stages
          .map((stage) => stage.steps)
          .flat()
          .map((step) => step.scriptItems)
          .flat()
        costEstimate.storyboard[storyboardKey].totalPrice = 0

        storyboardScriptItems.forEach((scriptItem) => {
          if (scriptItem.confirmed) {
            costEstimate.storyboard[storyboardKey].totalPrice +=
              scriptItem.costEstimate * scriptItem.amount
          }
        })
        costEstimate.total += costEstimate.storyboard[storyboardKey].totalPrice
      })
      return costEstimate
    }
  },
  data: () => ({
    loading: null
  }),
  methods: {
    ...mapActions('category', ['getCategories']),
    ...mapActions('item', ['getItems']),
    ...mapActions('storyboard', ['getStoryboards']),
    ...mapActions('stage', ['getStages']),
    ...mapActions('step', ['getSteps']),
    ...mapActions('scriptitem', ['getScriptItems']),
    ...mapActions('type', ['getTypes']),
    async getData() {
      this.loading = true
      const event = this.$store.state.event.activeEvent

      await this.getTypes()
      await this.getCategories(event.id)
      await this.getItems(event.id)
      await this.getStoryboards(event.id)
      await this.getStages(event.id)
      await this.getSteps(event.id)
      /* scriptItem.confirmed === false 
         means that script item is at "working area"
         and should not be included in budget
      */
      await this.getScriptItems({ eventId: event.id, excludeUncorfirmed: true })

      this.loading = false
    },
    mainCategoryTree(type) {
      let categories
      let items = JSON.parse(JSON.stringify(this.$store.state.item.items))
      if (type) {
        categories = JSON.parse(
          JSON.stringify(this.$store.state.category.categories)
        ).filter((category) => category.type.id === type.id)
      } else {
        categories = JSON.parse(
          JSON.stringify(this.$store.state.category.categories)
        )
      }
      categories = categories.sort((a, b) =>
        a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      )
      categories = categories.map((category) => {
        category.children = category.children.map((subCategory) => {
          subCategory.items = items.filter(
            (item) => item.category && item.category.id === subCategory.id
          )
          return subCategory
        })
        return category
      })
      return categories.filter((category) => !category.parent)
    },
    exportToXls(tab, data) {
      const rows = []
      let sort
      switch (tab) {
        case 0:
          sort = [
            'Type',
            'Main Category',
            'Sub Category',
            'Item',
            'Script Item'
          ]
          data.forEach((type) => {
            if (type.categories) {
              type.categories.forEach((mainCategory) => {
                if (mainCategory.children) {
                  mainCategory.children.forEach((subCategory) => {
                    if (subCategory.items) {
                      subCategory.items.forEach((item) => {
                        if (item.scriptItems) {
                          item.scriptItems.forEach((scriptItem) => {
                            const row = {
                              Type: type.name,
                              'Main Category': mainCategory.name,
                              'Sub Category': subCategory.name,
                              Item: item.name
                            }

                            if (typeof scriptItem.item !== 'object') {
                              scriptItem.item =
                                this.$store.state.item.items.find(
                                  (item) => item.id === scriptItem.item
                                )
                            }
                            row['Script Item'] = scriptItem.step
                              ? scriptItem.step.name
                              : '-'
                            row['Items Required'] = scriptItem.amount
                            row['Unit'] = scriptItem.item
                              ? scriptItem.item.unit
                              : ''
                            row['Cost estimate per unit'] =
                              scriptItem.costEstimate
                            row['Total cost estimate'] =
                              scriptItem.amount * scriptItem.costEstimate
                            rows.push(row)
                          })
                        }
                      })
                    }
                  })
                }
              })
            }
          })
          break

        case 1:
          sort = ['Storyboard', 'Stage', 'Step', 'Script Item']
          data.forEach((storyboard) => {
            if (storyboard.stages) {
              storyboard.stages.forEach((stage) => {
                if (stage.steps) {
                  stage.steps.forEach((step) => {
                    if (step.scriptItems) {
                      step.scriptItems.forEach((scriptItem) => {
                        const row = {
                          Storyboard: storyboard.name,
                          Stage: stage.name,
                          Step: step.name
                        }
                        if (typeof scriptItem.item !== 'object') {
                          scriptItem.item = this.$store.state.item.items.find(
                            (item) => item.id === scriptItem.item
                          )
                        }
                        row['Script Item'] = scriptItem.item
                          ? scriptItem.item.name
                          : '-'
                        row['Items Required'] = scriptItem.amount
                        row['Unit'] = scriptItem.item
                          ? scriptItem.item.unit
                          : ''
                        row['Cost estimate per unit'] = scriptItem.costEstimate
                        row['Total cost estimate'] =
                          scriptItem.amount * scriptItem.costEstimate
                        rows.push(row)
                      })
                    }
                  })
                }
              })
            }
          })
          break
      }

      const payload = {
        rows: rows,
        sort: sort
      }

      const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload),
        responseType: 'blob'
      }

      return fetch(
        process.env.VUE_APP_API_URL + '/file/generate/xls',
        requestOptions
      )
        .then((response) => response.blob())
        .then((blobTxt) => {
          var blob = new Blob([blobTxt], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          var win = window.open('', '_blank')
          var URL = window.URL || window.webkitURL
          var dataUrl = URL.createObjectURL(blob)
          win.location = dataUrl

          return true
        })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
